import classNames from "classnames/bind";
import styles from "./ConfigLockObject.module.css";
import Filter from "./Filter";
import { useEffect, useState } from "react";
import { Alert, Button, Empty, ImageObject, Loading, Pagination, Table, Toast } from "../../../../../components";
import { colum } from "./configTableLockObject";
import { objectLockFRS } from "../../../../../services/api/objectLockFRS";
import { DeleteIcon } from "../../../../../components/Icons/Icons";
import { checkRoleSupAdmin, getTimeFormArray } from "../../../../../utils";
import axiosClient from "../../../../../services/axiosClient";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const ConfigLockObject = ({ cameraCode, ...props }) => {
    const { onClose, motionStatus, handleTurnOnMotion, companyOfCam, statusAi } = props;
    // console.log(companyOfCam);
    const [filter, setFilter] = useState({
        name: null,
        department: null,
        page: 1,
        totalPage: 1,
        size: 10,
        organizationCode: companyOfCam?.company_code || null,
        cameraCode: cameraCode,
        organizationName: companyOfCam?.company_name || null
    });
    const [reFresh, setReFresh] = useState(false);
    const [alertDelete, setAlertDelete] = useState({
        show: false,
        id: null
    })
    const [listObject, setListObject] = useState([]);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const handleChangeFilter = (key, value) => {
        setFilter(pre => ({ ...pre, [key]: value, page: 1 }))
    }

    const handleCancel = () => {
        setAlertDelete({
            show: false,
            id: null
        })
    }

    const handleDelete = async () => {
        try {
            await objectLockFRS.deleteObject(alertDelete?.id)
            setReFresh(!reFresh)
            Toast.open(t('faceDetect.Remove_object_from_list_successfully'), "success")
            setFilter(pre => ({ ...pre, page: 1 }))
            handleCancel()
        } catch (error) {
            Toast.open(t('faceDetect.Removing_object_from_list_failed'), "danger")
        }
    }

    const handleChosePage = (page) => {
        setFilter(prev => ({ ...prev, page: page }))
    }
    const handleNextPage = () => {
        setFilter(prev => ({ ...prev, page: prev.page + 1 }))
    }
    const handlePrevPage = () => {
        setFilter(prev => ({ ...prev, page: prev.page - 1 }))
    }
    const handleConfirm = (id) => {
        setAlertDelete({
            id: id,
            show: !!id
        })
    }
    const handleAccept = async () => {
        // if (!motionStatus && statusAi) {
            // await handleTurnOnMotion(cameraCode)
        // }
        onClose()
    }
    const getListObjectInLockFile = async () => {
        setLoading(true)
        try {
            const param = {
                id_department: filter?.department,
                nameStaff: filter?.name,
                page: filter?.page,
                limit: filter?.size,
                organization_code: filter?.organizationCode === 'all' ? null : filter?.organizationCode,
                camera_code: cameraCode
            }
            const res = await objectLockFRS.getList(param)
            const objects = res?.data?.map((item, index) => {
                return {
                    id: item?.id,
                    stt: index + 1,
                    name: item?.staffName || '',
                    department: item?.nameDepartment || "",
                    time: item?.timeAdd ? getTimeFormArray(item?.timeAdd) : '',
                    organization_name: item?.organizationName || "",
                    avatar: <ImageObject src={item?.image} />,
                    action: <div className={cx('action')}>
                        <span onClick={() => handleConfirm(item?.id)}>
                            <DeleteIcon />
                        </span>
                    </div>
                };
            })
            setListObject(objects)
            setFilter(pre => ({ ...pre, totalPage: Math.ceil(res?.totalElement / filter?.size) }))
            setLoading(false)
        } catch (error) {
            Toast.open(t('faceDetect.Get_list_of_objects_failed'), "danger")
            // console.log(error);
        }
    }
    useEffect(() => {
        getListObjectInLockFile()
    }, [cameraCode,
        reFresh,
        filter?.name,
        filter?.department,
        filter?.organizationCode,
        filter?.page
    ])
    const handleCancelConfig = () => {
        if (onClose) {
            onClose();
        }
    }
    return (
        <div className={cx("wrraper")}>
            {alertDelete?.show && <Alert title={t('faceDetect.Do_you_want_to_delete_this_object')} onClose={handleCancel} onOk={handleDelete} />}
            <Filter
                value={filter}
                onChangeFilter={(key, value) => handleChangeFilter(key, value)}
                onReFresh={() => setReFresh(!reFresh)}
                organizationCode={companyOfCam}
            />
            <Table colum={colum} data={listObject} />
            {loading && <div className={cx('loading')}><Loading /></div>}
            {listObject?.length > 0 && <div className={cx('pagination')}>
                <Pagination
                    pages={filter.totalPage}
                    currentPage={filter.page}
                    onClick={handleChosePage}
                    onNext={handleNextPage}
                    onPrevious={handlePrevPage}
                />
            </div>}
            {/* {modalLoad && <div className={cx('modalLoad')}><Loading /></div>} */}
            {listObject?.length === 0 && !loading && <Empty title={t('smartReport.noDataMatch')} />}
            <div className={cx('footer')}>
                {/* <Button
                    title={'Cài lại mặc định'}
                    className={cx("btn-save")}
                    onClick={handleSetDefault}
                /> */}
                <Button
                    title={t('stream.cancelCustom')}
                    className={cx("btn-cancle")}
                    onClick={handleCancelConfig}
                />
                <Button
                    title={t('settingCam.Save_settings')}
                    className={cx("btn-save")}
                    onClick={handleAccept}
                />
            </div>
        </div>
    )
}

export default ConfigLockObject;